<div class="desktop-navigation-dropdown">
  <div class="desktop-navigation-dropdown__arrow"></div>
  <ng-container *ngFor="let item of navigationItems">
    <div
      class="desktop-navigation-dropdown__item"
      [ngClass]="{
        'desktop-navigation-dropdown__item--has-divider': item.divider
      }"
      *ngIf="item.path"
      [routerLink]="item.path"
      (click)="onCloseDropdown()"
    >
      <app-icon [name]="item.icon"></app-icon>

      {{ item.title | t }}
    </div>
  </ng-container>
  <div
    class="desktop-navigation-dropdown__item"
    role="button"
    (click)="onLogout()"
  >
    <app-icon [name]="ICONS.LOGOUT_16"></app-icon>

    {{ "logout" | t }}
  </div>
</div>
